// extracted by extract-css-chunks-webpack-plugin
module.exports = {"DragBar":"DragBar_1LfcZ_v16-5-1"};